<template>
  <ParchmentDeliveryAddDialog
    :value="value"
    mode="edit"
    :record="record"
    :buying-station-id="buyingStationId"
    @input="$emit('input', $event)"
    @saved="$emit('saved')"
    @close="$emit('close')"
  />
</template>

<script>
import ParchmentDeliveryAddDialog from "./AddDialog.vue";

export default {
  name: "ParchmentDeliveryEditDialog",
  components: { ParchmentDeliveryAddDialog },
  props: {
    value: { type: Boolean, default: false },
    record: { type: Object, default: null },
    buyingStationId: { type: [Number, String], default: null },
  },
};
</script>
